exports = module.exports = require("../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ali-alime-errorpage .error {\n  width: 300px;\n  margin: 0 auto;\n  color: #999;\n  text-align: center;\n  margin-top: 100px;\n  font-size: 16px; }\n  .ali-alime-errorpage .error img {\n    width: 140px;\n    height: 150px; }\n  .ali-alime-errorpage .error p {\n    margin: 15px 50px; }\n  .ali-alime-errorpage .error a {\n    display: inline-block;\n    padding: 10px 0;\n    width: 120px;\n    color: #666;\n    border: 1px solid #999;\n    border-radius: 5px;\n    text-decoration: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.25.0@css-loader?{}!./node_modules/_sass-loader@4.0.2@sass-loader?{"sourceMap":true}!./node_modules/_postcss-loader@1.3.3@postcss-loader?{"sourceMap":true}!./src/bu/pc/base.scss
// module id = 325
// module chunks = 0